module.exports = __webpack_public_path__ + "img/fedex.d2288f89.png";